/* SPD PDP option/capacity enhancements — loaded as an external, deferred theme script (not inline)
   so it survives Content-Security-Policy rules and script-optimizer apps that strip/defer inline
   <script> tags. All work is confined to `.atc-info--product-options .option-section` and wrapped
   in an IIFE + try/catch, so it can neither leak globals nor throw a page-level error.

   Does three things:
     1. shrinkUnits()   — wraps the "TB"/"GB" unit of each capacity pill in <span class="cap-unit">.
     2. groupOptions()  — wraps the Options <li>s in a single non-wrapping .options-row.
     3. buildDropdowns()— mirrors each pill row into a native <select> (Options + Drive Capacity)
                          for mobile. Adds .dd-swapped to a row only after its dropdown is built;
                          mobile CSS hides a row only when it carries .dd-swapped, so if this script
                          never runs the pill rows stay visible instead of the list disappearing.

   NOTE: This handles the metafield-driven pill lists used by hard-drive products. JBOD products use
   NATIVE Shopify variants ("Storage Capacity" option); their checkout-card dropdown is rendered in
   Liquid and wired to the variant engine in product-template.liquid — not here. */
(function () {
  var UNIT_RE = /^(\d+(?:\.\d+)?)\s*(TB|GB|MB|PB)$/i;

  function shrinkUnits() {
    document.querySelectorAll('.atc-info--product-options .option-section a').forEach(function (a) {
      if (a.querySelector('.cap-unit')) return;            // already processed
      var m = a.textContent.trim().match(UNIT_RE);
      if (!m) return;                                       // not a capacity pill
      a.innerHTML = m[1] + '<span class="cap-unit">' + m[2] + '</span>';
    });
  }

  // True when a pill list is the Drive Capacity list (its items look like "18TB"/"512GB").
  function isCapacityList(anchors) {
    if (!anchors.length) return false;
    var cap = 0;
    anchors.forEach(function (a) { if (UNIT_RE.test(a.textContent.trim())) cap++; });
    return cap >= Math.ceil(anchors.length / 2);
  }
  function directAnchors(el) {
    return Array.prototype.slice.call(el.querySelectorAll(':scope > li a'));
  }

  // Wrap ONLY the Options list's <li>s in a .options-row so they form one non-wrapping row.
  // The metafield markup is inconsistent: usually the Options <ul> is left unclosed so the
  // Drive Capacity list nests inside it, but on well-formed products the two lists are separate
  // sibling <ul>s. So we take the FIRST direct-child <ul> and only wrap it when it is NOT the
  // capacity list — that way we never wrap the capacity items (which broke the capacity dropdown).
  function groupOptions() {
    document.querySelectorAll('.atc-info--product-options .option-section').forEach(function (sec) {
      var ul = sec.querySelector(':scope > ul');
      if (!ul || ul.querySelector(':scope > .options-row')) return;
      if (isCapacityList(directAnchors(ul))) return;                     // first list is capacity → leave it
      var lis = Array.prototype.filter.call(ul.children, function (c) { return c.tagName === 'LI'; });
      if (lis.length < 2) return;
      var row = document.createElement('div');
      row.className = 'options-row';
      ul.insertBefore(row, lis[0]);                                      // keep original position
      lis.forEach(function (li) { row.appendChild(li); });
    });
  }

  // Build a native <select> mirror of each pill list (Options + Drive Capacity) for mobile.
  // Structure-agnostic: any container that directly holds <li><a> pills becomes a dropdown, and
  // its label is decided by content (capacity vs options) rather than by nesting position — so it
  // works whether the two lists are nested or separate siblings. Each pill is an <a href> to
  // another product; the current one has no href + .selected-option.
  function buildDropdowns() {
    document.querySelectorAll('.atc-info--product-options .option-section').forEach(function (sec) {
      var containers = Array.prototype.slice.call(sec.querySelectorAll('.options-row, ul')).filter(function (el) {
        return el.querySelector(':scope > li a');                       // holds pills directly
      });
      containers.forEach(function (el) {
        var prev = el.previousElementSibling;
        if (prev && prev.classList && prev.classList.contains('opt-dd')) return;  // already built
        var anchors = directAnchors(el);
        if (!anchors.length) return;
        var sel = document.createElement('select');
        sel.className = 'opt-dd';
        sel.setAttribute('aria-label', isCapacityList(anchors) ? 'Drive Capacity' : 'Options');
        anchors.forEach(function (a) {
          var opt = document.createElement('option');
          var href = a.getAttribute('href');
          var current = a.closest('li').classList.contains('selected-option') || !href;
          opt.value = current ? '' : (href || '');
          opt.textContent = a.textContent.trim().replace(/\s+/g, ' ');
          if (current) opt.selected = true;
          sel.appendChild(opt);
        });
        sel.addEventListener('change', function () {
          if (sel.value) window.location.href = sel.value;
        });
        el.parentNode.insertBefore(sel, el);
        el.classList.add('dd-swapped');
      });
    });
  }

  function run() {
    try { shrinkUnits(); } catch (e) { /* leave capacity text as-is */ }
    try { groupOptions(); } catch (e) { /* leave option pills ungrouped */ }
    try { buildDropdowns(); } catch (e) { /* pill rows stay visible (see .dd-swapped) */ }
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  } catch (e) { /* no-op */ }
})();
